import { z } from "zod";
import RefurbishmentProcess from "@/pages/RefurbishmentProcess";
import RepairProcess from "@/pages/RepairProcess";
import HarvestProcess from "@/pages/HarvestProcess";
import type { ModuleProps } from "../types";

export const dynamicPhasesConfig = z.object({
  /** Optional category filter (e.g. "error_codes" only). */
  filter: z.string().optional(),
});
export type DynamicPhasesConfig = z.infer<typeof dynamicPhasesConfig>;

/**
 * The 6-phase workflow_items engine. Renders the matching legacy page
 * component directly so all behaviour (phase grid, error-code branching,
 * brushless filter, PhaseTimer, Smart Navigation) is preserved.
 *
 * The legacy pages read `:id` from the route and `workOrderId` from the
 * query string — both are guaranteed to be present on the runner URL
 * (`/appliance/:id/workflow/:workflowKey?workOrderId=...`).
 */
export function DynamicPhasesModule({ workflowKey }: ModuleProps<DynamicPhasesConfig>) {
  if (workflowKey === "harvesting") return <HarvestProcess />;
  if (workflowKey === "repair") return <RepairProcess />;
  return <RefurbishmentProcess />;
}
